import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '0px 30px 20px 30px',
    marginTop: '130px'
  },
  menuGroup: {
    display: 'flex',
    width: '100%',
    marginTop: '10px',
    marginBottom: '30px',
    padding: '20px 0px 0px 0px',
  },
  centerDiv: {
    width: '100%',
    textAlign: 'center',
  },
  linkGroup: {
    textDecoration: 'none',
  },
  button: {
    color: 'rgb(24, 116, 185)',
    fontSize: 17,
    background: 'none',
    border: 'none',
    boxShadow: 'none',
  },
  loadingDiv: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  marginBottom: {
    marginBottom: 40,
  },
  findBox: {
    width: '100%',
  },
  inputsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'end'
  },
  textFieldParent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '-2px 4px 5px 0px rgba(0, 0, 0, 0.1)',
    padding: '0 0 0px 10px',
    height: 62,
    background: '#fff',
  },
  findIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#1874b9',
    color: '#fff',
    height: '100%',
    width: '60px',
    cursor: 'pointer',
  },
  printReportText: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    color: '#1874B9',
    marginBottom: 10,
    transition: 'all .2s',
    "&:hover": {
      transform: "scale(1.1)",
    }
  },
  debitsTitle: {
    marginTop: '1.2em',
    marginLeft: '1.2em'
  },
  infoDAM: {
    background: 'white',
    padding: 12,
    boxShadow: '2px 2px 6px 0px #80808047',
    borderRadius: 6,
    marginLeft: '1.2em'
  },
  groupButtons: {
    display: 'flex',
    alignItems: 'end'
  },
  infoColumns: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  }
}))

export default useStyles